<template>
  <ul v-if="transactions.length" class="sc-card-list mt-4">
    <li
      class="sc-card-list-item d-flex align-items-center p-0"
      v-for="(transaction, index) in transactions"
      :key="index"
    >
      <b-tooltip :target="'transaction' + index" placement="top">
        Tipo da transação: {{ transaction.transaction_type }}
      </b-tooltip>
      <div :id="'transaction' + index" class="flex-fill d-flex align-items-center flex-nowrap mr-3">
        <span class="mr-3 ml-2 h-box" :class="transactionTypeClass(transaction.type)">
          {{ transaction.type }}
        </span>
        <span class="text-size-4 text-weight-medium font-public-sans">
          {{ formattedTransaction(transaction) }}
        </span>
      </div>

      <div class="flex-fill d-flex align-items-end flex-column">
        <h4 class="text-size-4 text-weight-medium text-right" :style="useStyles.colorDark">
          {{ transaction.ammount }}
        </h4>
        <h6  class="text-size-3 text-weight-medium text-right" :style="useStyles.colorGray">
          {{ format(transaction.transaction_date) }}
        </h6>
      </div>
    </li>
  </ul>
  <div v-else class="d-flex align-items-center flex-column justify-content-center h-100">
    <p class="text-size-4 text-weight-regular">Nenhuma movimentação realizada.</p>
  </div>
</template>

<script>
import { formatDate } from "./../utils/masks/formatSlotDate";
export default {
  name: 'BankTransactionsHistory',
  props: {
    transactions: {
      type: Array,
      default: () => [],
    }
  },
  methods: {
    format(date) {
      return formatDate(date, "dd 'de' MMMM 'de' YYY");
    },
    formattedTransaction(transaction) {
      if (transaction.description === 'Pedido de saque') {
        return transaction.description;
      }
      let formattedDescription = transaction.description.substring(0, 18);
      return `${formattedDescription} por consulta com o paciente ${transaction.patient}`;
    },
    transactionTypeClass(type) {
      return type === 'débito' ? 'text-color-danger' : 'text-color-success';
    }
  },
  computed: {
    useStyles() {
      return {
        colorDark: {
          color: "#343a40"
        },
        colorGray: {
          color: "#868E96"
        }
      };
    }
  }
}
</script>

<style>
  .h-box {
    width: 100%;
    max-width: 70px;
  }
</style>